import { Link } from "react-router-dom";
import { CONTACT, NAV } from "./data";

export const Footer = () => (
  <footer className="bg-black text-neutral-400 border-t border-white/10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-5">
          <div className="font-display font-black text-3xl silver-text leading-none">P.M.R.</div>
          <div className="font-grotesk text-[10px] tracking-[0.32em] uppercase text-neutral-500 mt-1">Physio · Mobil · Roider</div>
          <p className="font-body italic text-neutral-300 mt-4">Private Physiotherapie</p>
          <p className="font-body text-sm mt-4 max-w-xs leading-relaxed">
            Mobile Physiotherapie mit Hausbesuch in Dachau und Umgebung.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="font-grotesk text-xs tracking-[0.2em] uppercase text-neutral-500 mb-4">Navigation</div>
          <ul className="space-y-3 font-body text-sm">
            {NAV.map((n) => (
              <li key={n.href}><a href={n.href} className="hover:text-white transition-colors">{n.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <div className="font-grotesk text-xs tracking-[0.2em] uppercase text-neutral-500 mb-4">Kontakt</div>
          <ul className="space-y-3 font-body text-sm">
            <li><a href={CONTACT.phoneHref} className="hover:text-[var(--pmr-red)] transition-colors">{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
            <li>{CONTACT.street}</li>
            <li>{CONTACT.city}</li>
          </ul>
        </div>
      </div>

      <div className="silver-rule mt-14 mb-8" />
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 font-body text-xs text-neutral-600">
        <span>© {new Date().getFullYear()} P.M.R. – Timo Roider. Alle Rechte vorbehalten.</span>
        <div className="flex items-center gap-6">
          <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          <span>{CONTACT.web}</span>
        </div>
      </div>
    </div>
  </footer>
);
